<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <p>
          Search Users By Email:
          <input v-model="email" type="text" name="email" autofocus />
        </p>
        <p>
          <button class="big-btn blue" @click="searchUsers()">
            Search Users
          </button>
        </p>
        <br />
        <br />
        <table v-if="users.length">
          <h4>Users:</h4>
          <tr>
            <th>Email</th>
            <th>Premium</th>
            <th>Edit</th>
          </tr>
          <tr v-for="user in users" :key="user.id">
            <td>{{ user.email }}</td>
            <td>{{ user.premium === "1" ? "Yes" : "No" }}</td>
            <td>
              <button class="btn orange" @click="editUser(user)">
                Edit
              </button>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import UserRepository from "../../data/user.repository";
export default {
  data() {
    return {
      email: "",
      users: [],
    };
  },
  methods: {
    searchUsers() {
      UserRepository.searchByEmail(this.email).then((data) => {
        this.users = data;
      });
    },
    editUser(user) {
      this.$store.state.editUser = user;
      this.$router.push({ path: "/admin/users/edit" });
    },
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// Users.vue?a7fcdb5a